<script lang="ts">
    import {
        debug,
        mainMenu,
        pagesAvailableInPlanningMode,
        pagesAvailableInReadOnlyMode,
        readonlyMode,
        planning
    } from '../../../stores/store';
    import { _ } from 'svelte-i18n';
    import MainMenuVerticalElement from './MainMenuVerticalElement.svelte';
    import IconLeftPanelClose from '../Icons/IconLeftPanelClose.svelte';
    import IconLeftPanelOpen from '../Icons/IconLeftPanelOpen.svelte';
    import { app } from '../../../stores/app';
    import { features } from '../Features/features';
    import { api } from '../../../stores/api';
    import { WarehouseApi } from '../../components/Warehouses/WarehouseApi';
    import { VehiclesApi } from '../../components/Vehicles/VehiclesApi';
    import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
    import { TacticalPlanApi, type TacticalPlanResponseType } from '../../components/TacticalPlan/TacticalPlanApi';
    import { WeekSchedule } from '../../utilities/WeekSchedule';
    import { JobApi } from '../../components/Jobs/JobApi';

    interface NotificationRequest {
        item: any,
        promise: Promise<any>|null,
        handler: Function|null
    };

    let currentNotifications: any = {};
    let selectedDay: string = '';

    function onNotificationUpdate(id: string, notification: any) {
        currentNotifications[id] = notification;
        $mainMenu.items[$mainMenu.items.findIndex((i) => i.id === id)].notification = notification;
        if ($mainMenu.autoShowNotification) {
            let pending = Object.values(currentNotifications).filter((n:any) => n.pending === true);
            if (pending.length == 0) {
                let topNotification: any = null;
                for (let i in currentNotifications) {
                    let itemIndex = $mainMenu.items.findIndex((it) => it.id === i);
                    if ($mainMenu.items[itemIndex].notification) {
                        $mainMenu.items[itemIndex].notification.showAuto = false;
                        if (currentNotifications[i].priority && ($mainMenu.autoShowNotification === true || currentNotifications[i].priority <= $mainMenu.autoShowNotification)) {
                            if (topNotification === null || topNotification.notification.priority < currentNotifications[i].priority) {
                                topNotification = {id: i, notification: currentNotifications[i]};
                            }
                        }
                    }
                }
                if (topNotification) {
                    let itemIndex = $mainMenu.items.findIndex((i) => i.id === topNotification.id);
                    if ($mainMenu.items[itemIndex].notification) {
                        $mainMenu.items[itemIndex].notification.showAuto = true;
                    }
                    $mainMenu.autoShowNotification = topNotification.notification.priority;
                }
            }
        }
        $mainMenu = $mainMenu;
    }

    $: {
        $features = $features;
        // FIXME: dirty hack -- remove $app
        let notificationRequests: NotificationRequest[] = [];
        $mainMenu.items.forEach(item => {
            switch (item.id) {
                case 'PageWorkshop':
                case 'PageStart':
                    if ($app.isAdmin) {
                        item.visibleInMenu = $debug;
                        item.visible = $debug;
                    }
                    break;
                case 'PageGanttCouriers':
                    item.visible = $features.feature_enable_page_gantt_couriers;
                    item.visibleInMenu = $features.feature_enable_page_gantt_couriers;
                    break;
                case 'PageEasyVrp':
                    item.visible = $features.feature_easyvrp_enable_import_history;
                    item.visibleInMenu = $features.feature_easyvrp_enable_import_history;
                    break;
                case 'PageJobModifyTimeWindowRule':
                    item.visible = $app.account?.getSettingsReadonly()?.enable_job_modify_time_window_rule;
                    item.visibleInMenu = $app.account?.getSettingsReadonly()?.enable_job_modify_time_window_rule;
                    break;
                case 'PageAdmin':
                    if ($app.isAdmin) {
                        item.visible = true;
                        item.visibleInMenu = true;
                    }
                    break;
            }
            if ($readonlyMode && !pagesAvailableInReadOnlyMode.includes(item.id)) {
                item.visibleInMenu = false;
                item.visible = false;
            }
            if ($features.feature_ux_improvements && item.visibleInMenu && item.notification?.reload) {
                let itemIndex = $mainMenu.items.findIndex((i) => i.id === item.id);
                item.notification.reload = false;
                item.notification.priority = 0;
                $mainMenu.items[itemIndex].notification = item.notification;
                currentNotifications[item.id] = {...item.notification, pending: true};
                let promise = null;
                let handler = null;
                switch (item.id) {
                    case 'PageWarehouses':
                        promise = WarehouseApi.getCountAll($api);
                        handler = (item: any, response: any) => {
                            if (response.count === 0) {
                                item.notification.priority = 100;
                                item.notification.type = 'error';
                                item.notification.text = $_('MenuNotification_NoWarehouses');
                            } else {
                                item.notification.type = 'none';
                            }
                            return item;
                        };
                        break;
                    case 'PageVehicles':
                        promise = VehiclesApi.getCount($api, new ApiFilterBuilder(0));
                        handler = (item: any, response: any) => {
                            if (response.count === 0) {
                                item.notification.priority = 90;
                                item.notification.type = 'error';
                                item.notification.text = $_('MenuNotification_NoVehicles');
                            } else {
                                item.notification.type = 'none';
                            }
                            return item;
                        };
                        break;
                    case 'PageTacticalPlan':
                        promise = TacticalPlanApi.getAll($api);
                        handler = (item: any, response: any) => {
                            if (response.length === 0) {
                                item.notification.priority = 50;
                                item.notification.type = 'error';
                                item.notification.text = $_('MenuNotification_NoTacticalPlans');
                            } else {
                                let plansForToday = response.filter((tp: TacticalPlanResponseType) => WeekSchedule.isChecked(WeekSchedule.getBitSumForDate($planning.selectedDay), tp.week_schedule));
                                console.log('MainMenuVertical, TacticalPlan, plansForToday', plansForToday);
                                if (plansForToday.length === 0) {
                                    item.notification.type = 'error';
                                    item.notification.text = $_('MenuNotification_NoTacticalPlansForCurrentDay');
                                } else {
                                    item.notification.type = 'none';
                                }
                            }
                            return item;
                        };
                        break;
                    case 'PagePlanning':
                        let today = (function () {
                            let d = new Date();
                            return (
                                d.getFullYear() +
                                '-' +
                                ('0' + (d.getMonth() + 1)).slice(-2) +
                                '-' +
                                ('0' + d.getDate()).slice(-2)
                            );
                        })();
                        promise = Promise.all([
                            JobApi.getCountWithQueries(
                                $api,
                                {
                                    coords_accepted: true,
                                    process_stage: { $lt: 20 },
                                    completed_as_planned: null
                                },
                                new ApiFilterBuilder(1)
                            ),
                            JobApi.getCountWithQueries(
                                $api,
                                {
                                    coords_accepted: true,
                                    process_stage: { $lt: 20 },
                                    completed_as_planned: null,
                                    $or: [
                                        {$and: [{target_date: 'not_null'}, {target_date: {$lte: today}}]},
                                        {$and: [{target_date: null}, {end_date: 'not_null'}, {end_date: {$lte: today}}]}
                                    ]
                                },
                                new ApiFilterBuilder(1)
                            ),
                            JobApi.getCountWithQueries(
                                $api,
                                {
                                    process_stage: { $gte: 20 },
                                },
                                new ApiFilterBuilder(1)
                            )
                        ]);
                        handler = (item: any, response: any) => {
                            if (response[1].count > 0) {
                                item.notification.priority = 0;
                                item.notification.type = 'error';
                                item.notification.text = $_('MenuNotification_UnassignedJobsForToday');
                            } else if (response[0].count > 0) {
                                if (response[2].count == 0) {
                                    item.notification.priority = 10;
                                    item.notification.type = 'error';
                                    item.notification.text = $_('MenuNotification_UnassignedJobsNoAssigned');
                                } else {
                                    item.notification.type = 'info';
                                    item.notification.text = $_('MenuNotification_UnassignedJobs');
                                }
                            } else {
                                item.notification.type = 'none';
                            }
                            return item;
                        };
                        break;
                    case 'PageOrdersToBeCompleted':
                        promise = Promise.all([
                            JobApi.getCountWithQueries(
                                $api,
                                {},
                                new ApiFilterBuilder(1)
                            ),
                            JobApi.getCountWithQueries(
                                $api,
                                {coords_accepted: false},
                                new ApiFilterBuilder(1)
                            )
                        ]);
                        handler = (item: any, response: any) => {
                            if (response[0].count === 0 || response[1].count > 0) {
                                item.notification.priority = 30;
                                item.notification.type = 'error';
                                item.notification.text = response[0].count === 0 ? $_('MenuNotification_NoJobs') : $_('MenuNotification_JobsNotGeocoded');
                            } else {
                                item.notification.type = 'none';
                            }
                            return item;
                        };
                        break;
                }
                notificationRequests.push({item: item, promise: promise, handler: handler});
            }
        });
        if (notificationRequests.length) {
            Promise.all(notificationRequests.map((r) => r.promise)).then((response) => {
                for (let i = 0; i < response.length; i++) {
                    let request = notificationRequests[i];
                    if (typeof(request.handler) == 'function') {
                        let item = request.handler(request.item, response[i]);
                        onNotificationUpdate(item.id, item.notification);
                    }
                }
                $mainMenu = $mainMenu;
            });
        }
        $mainMenu = $mainMenu;
    }

    $: {
        if ($features.feature_ux_improvements && $planning.selectedDay != selectedDay) {
            if (selectedDay) {
                let tacticalPlanMenuItem = $mainMenu.items.find((i) => i.id == 'PageTacticalPlan');
                if (tacticalPlanMenuItem?.notification) {
                    tacticalPlanMenuItem.notification.reload = true;
                    $mainMenu = $mainMenu;
                }
            }
            selectedDay = $planning.selectedDay;
        }
    }
</script>

<div class="menu-container" class:expanded={$mainMenu.expanded}>
    <div class="menu-tab">
        <div class="menu-item-list-start">
            {#each $mainMenu.items.filter(item => item.side !== 'right' && item.visibleInMenu) as item, index (item.id)}
                <MainMenuVerticalElement {item} />
            {/each}
        </div>
        <div class="menu-item-list-end">
            {#each $mainMenu.items.filter(item => item.side === 'right' && item.visibleInMenu) as item, index (item.id)}
                <MainMenuVerticalElement {item} />
            {/each}
        </div>
        <div
            class="menu-visibility-toggle"
            on:click={() => {
                $mainMenu.expanded = !$mainMenu.expanded;
            }}
        >
            {#if $mainMenu.expanded}
                <IconLeftPanelClose />
            {:else}
                <IconLeftPanelOpen />
            {/if}
        </div>
    </div>
</div>

<style>
    :root {
        --border-color: #f2f2f2;
    }
    .menu-container {
        display: flex;
        height: 100%;
        flex-direction: column;
    }
    .menu-container.expanded {
        width: 180px;
        /*transition: 0.3s;*/
    }
    .menu-tab {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 1fr 40px;
        grid-template-areas:
            'menu-items-start'
            'menu-items-end'
            'menu-visibility-toggle';
        /*display: flex;*/
        /*justify-content: space-between;*/
        /*flex-direction: column;*/
        padding: 0 0 0 0;
        /*border-right: 4px solid #d4d4d488;*/
        border-right: 4px solid var(--border-color);
        background-color: white;
        width: 100%;
        height: 100%;
    }
    .menu-item-list-start {
        grid-area: menu-items-start;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        column-gap: 10px;
        padding: 26px 6px 6px 6px;
        row-gap: 5px;
    }
    .menu-item-list-end {
        grid-area: menu-items-end;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        column-gap: 10px;
        padding: 6px 6px 26px 6px;
        row-gap: 5px;
    }
    .menu-visibility-toggle {
        grid-area: menu-visibility-toggle;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background-color: var(--border-color);
    }
    .menu-visibility-toggle :global(.icon) {
        opacity: 0.3;
    }
    .menu-visibility-toggle:hover {
        background-color: var(--main-selected-background);
        color: var(--main-selected-color);
    }
    .menu-visibility-toggle:hover :global(.icon) {
        opacity: 1;
    }
</style>
